<template>
  <div class="seller-panel">
    <div
      class="seller-titleblk"
      v-if="!$route.path.includes('/product-deal')"
    >
      <h4>{{$t('sellersName')}}</h4>
    </div>
    <div
      class="seller-list"
      v-if="!$route.path.includes('/product-deal')"
    >
      <ul v-if="sellerDetails.sellerItems && sellerDetails.sellerItems.length">
        <li
          v-for="(category, index) in sellerDetails.sellerItems"
          :key="index"
        >
          <div
            class="flx"
            v-if="category.sellerLiteDTO"
            style=" padding: 8px 15px 0 15px;align-items: baseline;"
          >
            <span class="seller-shop-name">
              <span>{{category.sellerLiteDTO.storeName}} </span>
              <span
                class="is-verified"
                v-if="category.sellerLiteDTO.isApproved"
              ><img
                  src="../../../assets/images/icons/verified-icon.png"
                  alt="loader"
                /></span></span>

            <a
              @click="callShop($event, category.sellerLiteDTO.phone)"
              class="call-icon"
              v-if="category.sellerLiteDTO && category.sellerLiteDTO.phone && !category.sellerLiteDTO.isGlobalShop && $cookie.get('version-code')"
            >
              <Call-icon />
            </a>
          </div>
          <div
            class="free-delivery-tag"
            v-if="category.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable"
          >
            <span class="truck-badge">
              <TruckIcon />
            </span>
            <span
              class="seller-status"
              id="seller-status"
              v-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges >'0.0' && (category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === null || category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === '0.0')"
            >Home delivery available with ₹{{category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges}} delivery charges</span>
            <span
              class="seller-status"
              id="seller-status"
              v-else-if="(category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === '0.0') && category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount > '0.0'"
            >Free home delivery Available with minimum ₹{{category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount}} order</span>
            <span
              class="seller-status"
              id="seller-status"
              v-else-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ===null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' "
            >Free home delivery Available </span>
            <span class="triangle-badge"><img
                src="../../../assets/images/triangle_label.png"
                alt="loader"
              /></span>
          </div>
          <!-- <div class="seller-dtlblk free-delivery-tag1" v-if="category.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable">
            <div class="seller-info" style="width:100%">
              <div class="flx" style="align-items: baseline">
                
                <div class="info-col" v-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges >'0.0' && (category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === null || category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === '0.0')">
                  <span class="seller-status">Home delivery available with ₹{{category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges}} delivery charges</span>
                </div>                
                <div class="info-col" v-else-if="(category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === '0.0') && category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount > '0.0'">
                  <span class="seller-status">Free home delivery Available with minimum ₹{{category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount}} order</span>
                </div>
                <div class="info-col" v-else-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ===null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' ">
                  <span class="seller-status">Free home delivery Available</span>
                </div>            
              </div>
            </div>           
          </div> -->
          <div
            class="star-rating"
            @click="$router.push('/shop-rating/' + category.sellerLiteDTO.shopId + '?shopName=' + category.sellerLiteDTO.storeName)"
            v-if="category.sellerLiteDTO"
          >
            <div style="display: flex; width: 100%;justify-content: space-between;align-items: center;">
              <div style="display: flex;align-items: center;">
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="15"
                  active-color="#138808"
                  :rating="Number(category.sellerLiteDTO.averageRating)"
                  :show-rating="false"
                  v-if="category.sellerLiteDTO.averageRating"
                ></star-rating>
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="15"
                  active-color="#138808"
                  :rating="Number(1)"
                  :show-rating="false"
                  v-else
                ></star-rating>
                <span
                  style="color: #505050;"
                  v-if="category.sellerLiteDTO.averageRating"
                >{{Number(category.sellerLiteDTO.averageRating).toFixed(1)}}/5</span>
                <span
                  style="color: #505050;"
                  v-else
                >{{Number(1)}}/5</span>
              </div>
              <span :style="[
                            category.sellerLiteDTO.averageRating
                            ? { paddingLeft: 8 }
                            : { paddingLeft: 0 },
                        ]">{{$t('addReview')}}</span>
            </div>
          </div>
          <div
            class="seller-dtlblk"
            style="    padding-left: 10px;"
          >
            <div class="seller-info">
              <div
                class="flx"
                style="align-items: baseline"
              >
                <div
                  class="info-col"
                  v-if="category.sellerLiteDTO"
                >
                  <span
                    class="material-icons"
                    style="font-size: 1.05em"
                  >location_on</span>
                  <span class="seller-status">{{ category.sellerLiteDTO.sellerShopAddress.address }}, {{ category.sellerLiteDTO.sellerShopAddress.city }}
                  </span>
                </div>
              </div>
            </div>
            <div
              class="distance-info"
              v-if="$cookie.get('version-code')"
            >
              <span
                class="seller-status"
                style="
                display: flex;
                align-items: center;
                color: #0091ff;
                font-size: 0.75em;
              "
                v-if="
                category.hasOwnProperty('shopDistance') &&
                parseFloat(category.sellerLiteDTO.sellerShopAddress.latitude) >
                  0 &&
                parseFloat(category.sellerLiteDTO.sellerShopAddress.longitude) >
                  0
              "
                @click="
                openShopOnMap(
                  category.sellerLiteDTO.sellerShopAddress.latitude,
                  category.sellerLiteDTO.sellerShopAddress.longitude
                )
              "
              ><span
                  class="material-icons"
                  style="font-size: 1.25em;color:#505050"
                >directions_walk</span>
                ({{ Number(category.shopDistance).toFixed(2) }} {{$t('kmsAway')}})</span>
              <span
                class="seller-status"
                style="
                display: flex;
                align-items: center;
                color: #0091ff;
                font-size: 0.75em;
              "
                v-else-if="
                !category.hasOwnProperty('shopDistance') &&
                parseFloat(category.sellerLiteDTO.sellerShopAddress.latitude) >
                  0 &&
                parseFloat(category.sellerLiteDTO.sellerShopAddress.longitude) >
                  0
              "
                @click="getLocation()"
              ><span
                  class="material-icons"
                  style="font-size: 1.25em;color:#505050"
                >directions_walk</span>
                {{$t('seeDistance')}}</span>
            </div>

          </div>
          <div
            class="seller-dtlblk"
            style="padding:0 15px 8px 15px"
          >
            <span class="prdt-price">Rs. {{ parseFloat(category.sellingPrice) }}.00
              <strike v-if="
                    parseFloat(category.sellingPrice) < parseFloat(category.mrp)
                  ">Rs. {{ parseFloat(category.mrp) }}.00</strike></span>

          </div>
          <!-- <div class="see-all-offer" @click="isOfferListPopup = !isOfferListPopup" v-if="category.sellerLiteDTO && category.sellerLiteDTO.isApproved">
                <p>इस दूकान पर <span style="font-weight:normal">&#8377;</span> 50 से <span style="font-weight:normal">&#8377;</span> 500 का कैशबैक </p>
                <p class="see-now">अभी देखें <span class="material-icons">chevron_right</span> </p>
              </div> -->

          <div
            class="shipping-issue"
            v-if="!category.availableOnPincode"
          >
            {{$t('itemCannotBeShipped')}}
          </div>
          <div class="shop-action-blk">
            <p
              class="view-shop"
              @click="viewShop(category.sellerLiteDTO.shopId)"
            >
              {{$t('goToThisShop')}}
            </p>
            <div
              class="addtobeg-col"
              :class="{ 'disable-bag': !category.availableOnPincode }"
              @click="funcAddToBag(category.sellerItemRelationshipId)"
            >
              {{$t('addtoBag')}}
            </div>
          </div>
        </li>
        <div class="order_button">
          <div class="new_buy_button">
            <div class="">
              <span class="price">
                <span class="ruppee-sign">₹</span>
                {{parseFloat(sellerDetails.sellingPrice)}}.00
              </span>
              <span>
                <strike>₹{{parseFloat(sellerDetails.mrp)}}.00</strike>
              </span>
            </div>
            <div class="deal-item-added">
              <button
                type="button"
                class="large_group_btn group"
                @click="addToBag(sellerDetails.sellerItemRelationshipId)"
              >
                <span>{{$t('buyNow')}}</span>
              </button>
            </div>
          </div>
        </div>
      </ul>
      <ul v-else>
        <li>
          <div
            class="flx"
            v-if="sellerDetails.sellerLiteDTO"
            style=" padding: 8px 15px 0 15px;align-items: baseline;"
          >
            <span class="seller-shop-name">
              <span>{{sellerDetails.sellerLiteDTO.storeName}} </span>
              <span
                class="is-verified"
                v-if="sellerDetails.sellerLiteDTO.isApproved"
              ><img
                  src="../../../assets/images/icons/verified-icon.png"
                  alt="loader"
                /></span></span>

            <a
              @click="callShop($event, sellerDetails.sellerLiteDTO.phone)"
              class="call-icon"
              v-if="sellerDetails.sellerLiteDTO && sellerDetails.sellerLiteDTO.phone && !sellerDetails.sellerLiteDTO.isGlobalShop && $cookie.get('version-code')"
            >
              <Call-icon />
            </a>
          </div>
          <div
            class="star-rating"
            @click="$router.push('/shop-rating/' + sellerDetails.sellerLiteDTO.shopId + '?shopName=' + sellerDetails.sellerLiteDTO.storeName)"
            v-if="sellerDetails.sellerLiteDTO"
          >
            <div style="display: flex; width: 100%;justify-content: space-between;align-items: center;">
              <div style="display: flex;align-items: center;">
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="15"
                  active-color="#138808"
                  :rating="Number(sellerDetails.sellerLiteDTO.averageRating)"
                  :show-rating="false"
                  v-if="sellerDetails.sellerLiteDTO.averageRating"
                ></star-rating>
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="15"
                  active-color="#138808"
                  :rating="1"
                  :show-rating="false"
                  v-else
                ></star-rating>
                <span
                  style="color: #505050;"
                  v-if="sellerDetails.sellerLiteDTO.averageRating"
                >{{Number(sellerDetails.sellerLiteDTO.averageRating).toFixed(1)}}/5</span>
                <span
                  style="color: #505050;"
                  v-else
                >1/5</span>
              </div>
            </div>
          </div>
          <div
            class="seller-dtlblk"
            style="    padding-left: 10px;"
          >
            <div class="seller-info">
              <div
                class="flx"
                style="align-items: baseline"
              >
                <div
                  class="info-col"
                  v-if="sellerDetails.sellerLiteDTO"
                >
                  <span
                    class="material-icons"
                    style="font-size: 1.05em"
                  >location_on</span>
                  <span class="seller-status">{{ sellerDetails.sellerLiteDTO.sellerShopAddress.address }}, {{ sellerDetails.sellerLiteDTO.sellerShopAddress.city }}
                  </span>
                </div>
              </div>
            </div>
            <div
              class="distance-info"
              v-if="sellerDetails.sellerLiteDTO && $cookie.get('version-code')"
            >
              <span
                class="seller-status"
                style="
                display: flex;
                align-items: center;
                color: #0091ff;
                font-size: 0.75em;
              "
                v-if="
                sellerDetails.hasOwnProperty('shopDistance') &&
                parseFloat(sellerDetails.sellerLiteDTO.sellerShopAddress.latitude) >
                  0 &&
                parseFloat(sellerDetails.sellerLiteDTO.sellerShopAddress.longitude) >
                  0
              "
                @click="
                openShopOnMap(
                  sellerDetails.sellerLiteDTO.sellerShopAddress.latitude,
                  sellerDetails.sellerLiteDTO.sellerShopAddress.longitude
                )
              "
              ><span
                  class="material-icons"
                  style="font-size: 1.25em;color:#505050"
                >directions_walk</span>
                ({{ Number(sellerDetails.shopDistance).toFixed(2) }} {{$t('kmsAway')}})</span>
              <span
                class="seller-status"
                style="
                display: flex;
                align-items: center;
                color: #0091ff;
                font-size: 0.75em;
              "
                v-else-if="
                !sellerDetails.hasOwnProperty('shopDistance') &&
                parseFloat(sellerDetails.sellerLiteDTO.sellerShopAddress.latitude) >
                  0 &&
                parseFloat(sellerDetails.sellerLiteDTO.sellerShopAddress.longitude) >
                  0
              "
                @click="getLocation()"
              ><span
                  class="material-icons"
                  style="font-size: 1.25em;color:#505050"
                >directions_walk</span>
                {{$t('seeDistance')}}</span>
            </div>

          </div>
          <div
            class="seller-dtlblk"
            style="padding:0 15px 8px 15px"
          >
            <span class="prdt-price">Rs. {{ parseFloat(sellerDetails.sellingPrice) }}.00
              <strike v-if="
                    parseFloat(sellerDetails.sellingPrice) < parseFloat(sellerDetails.mrp)
                  ">Rs. {{ parseFloat(sellerDetails.mrp) }}.00</strike></span>

          </div>
          <!-- <div class="see-all-offer" @click="isOfferListPopup = !isOfferListPopup" v-if="sellerDetails.sellerLiteDTO && sellerDetails.sellerLiteDTO.isApproved">
                <p>इस दूकान पर <span style="font-weight:normal">&#8377;</span> 50 से <span style="font-weight:normal">&#8377;</span> 500 का कैशबैक </p>
                <p class="see-now">अभी देखें <span class="material-icons">chevron_right</span> </p>
              </div> -->

          <div
            class="shipping-issue"
            v-if="!sellerDetails.availableOnPincode"
          >
            {{$t('itemCannotBeShipped')}}
          </div>
          <div class="shop-action-blk">
            <p
              class="view-shop"
              @click="viewShop(sellerDetails.sellerLiteDTO.shopId)"
            >
              {{$t('goToThisShop')}}
            </p>
            <div
              class="addtobeg-col"
              :class="{ 'disable-bag': !sellerDetails.availableOnPincode }"
              @click="funcAddToBag(sellerDetails.sellerItemRelationshipId)"
            >
              {{$t('addtoBag')}}
            </div>
          </div>
        </li>
        <div class="order_button">
          <div class="new_buy_button">
            <div class="">
              <span class="price">
                <span class="ruppee-sign">₹</span>
                {{parseFloat(sellerDetails.sellingPrice)}}.00
              </span>
              <span>
                <strike>₹{{parseFloat(sellerDetails.mrp)}}.00</strike>
              </span>
            </div>
            <div class="deal-item-added">
              <button
                type="button"
                class="large_group_btn group"
                @click="addToBag(sellerDetails.sellerItemRelationshipId)"
              >
                <span>{{$t('buyNow')}}</span>
              </button>
            </div>
          </div>
        </div>
      </ul>

      <!-- <div
        class="more-tab"
        @click="simple_toggle(default_limit, sellerDetails.sellerItems.length)"
        v-if="sellerDetails.sellerItems && sellerDetails.sellerItems.length > 2"
      >
        <span>{{ limit_by === 2 ? "+ Show More" : "- Show Less" }}</span>
      </div> -->
    </div>
    <!-- <div class="all-seller-list seller-panel" v-if="openSellerList"> -->
    <div
      class="bottomToUp"
      v-if="openSellerList"
    ></div>
    <div
      class="bottomToUp_content item-deliver seller-panel"
      :class="{'activeBottomtoUp' : openSellerList}"
      v-if="openSellerList"
      style="    padding: 8px;margin:0;padding-bottom:0"
    >
      <div
        class="seller-titleblk"
        style="padding: 8px;"
      >
        <h4>{{$t('sellersName')}}</h4>
        <span
          class="closePopUp"
          @click="openSellerList =!openSellerList"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
          >
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
      <div
        class="seller-list"
        style="    max-height: calc(100vh - 52px);
    overflow: scroll;"
      >
        <ul v-if="sellerDetails.sellerItems && sellerDetails.sellerItems.length">
          <li
            v-for="(category, index) in sellerDetails.sellerItems"
            :key="index"
          >
            <div
              class="flx"
              v-if="category.sellerLiteDTO"
              style=" padding: 8px 15px 0 15px;align-items: baseline;"
            >
              <span class="seller-shop-name">{{
                category.sellerLiteDTO.storeName
              }} <span
                  class="is-verified"
                  v-if="category.sellerLiteDTO.isApproved"
                ><img
                    src="../../../assets/images/icons/verified-icon.png"
                    alt="loader"
                  /></span></span>
            </div>
            <div
              class="seller-dtlblk"
              style="    padding-left: 10px;"
            >
              <div class="seller-info">
                <div
                  class="flx"
                  style="align-items: baseline"
                >
                  <div
                    class="info-col"
                    v-if="category.sellerLiteDTO"
                  >
                    <span class="seller-status">{{ category.sellerLiteDTO.sellerShopAddress.address }}, {{ category.sellerLiteDTO.sellerShopAddress.city }}
                    </span>
                  </div>
                </div>
              </div>

            </div>
            <div
              class="seller-dtlblk"
              style="padding:0 15px 8px 15px"
            >
              <span class="prdt-price">Rs. {{ parseFloat(category.sellingPrice) }}.00
                <strike v-if="
                      parseFloat(category.sellingPrice) < parseFloat(category.mrp)
                    ">Rs. {{ parseFloat(category.mrp) }}.00</strike></span>
              <p
                class="new-add-to-bag"
                @click="buyNowFunc(category.sellerItemRelationshipId)"
              >
                {{$t('buyFromHere')}}
              </p>

            </div>
            <!-- <div class="see-all-offer" @click="isOfferListPopup = !isOfferListPopup" v-if="category.sellerLiteDTO && category.sellerLiteDTO.isApproved">
                <p>इस दूकान पर <span style="font-weight:normal">&#8377;</span> 50 से <span style="font-weight:normal">&#8377;</span> 500 का कैशबैक </p>
                <p class="see-now">अभी देखें <span class="material-icons">chevron_right</span> </p>
              </div> -->
            <div
              class="free-delivery-tag"
              v-if="category.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable"
            >
              <span class="truck-badge">
                <TruckIcon />
              </span>
              <span
                class="seller-status"
                id="seller-status"
                v-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges >'0.0' && (category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === null || category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === '0.0')"
              >Home delivery available with ₹{{category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges}} delivery charges</span>
              <span
                class="seller-status"
                id="seller-status"
                v-else-if="(category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === '0.0') && category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount > '0.0'"
              >Free home delivery Available with minimum ₹{{category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount}} order</span>
              <span
                class="seller-status"
                id="seller-status"
                v-else-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ===null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' "
              >Free home delivery Available </span>
              <span class="triangle-badge"><img
                  src="../../../assets/images/triangle_label.png"
                  alt="loader"
                /></span>
            </div>
            <!-- <div class="seller-dtlblk" style="background: rgb(241, 241, 241);margin: 0px 15px 8px;width: calc(100% - 30px);border-radius: 5px;" v-if="category.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable">
              <div class="seller-info" style="width:100%">
                <div class="flx" style="align-items: baseline">
                  
                  <div class="info-col" v-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges >'0.0' && (category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === null || category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount === '0.0')">
                    <span class="seller-status">Home delivery available with ₹{{category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges}} delivery charges</span>
                  </div>                
                  <div class="info-col" v-else-if="(category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === '0.0') && category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount > '0.0'">
                    <span class="seller-status">Free home delivery Available with minimum ₹{{category.sellerLiteDTO.sellerShopSettingDTO.minimumOrderAmount}} order</span>
                  </div>
                  <div class="info-col" v-else-if="category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges === null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ===null || category.sellerLiteDTO.sellerShopSettingDTO.deliveryCharges ==='0.0' ">
                    <span class="seller-status">Free home delivery Available</span>
                  </div>            
                </div>
              </div>
            
            </div> -->

            <div
              class="shipping-issue"
              v-if="!category.availableOnPincode"
            >
              {{$t('itemCannotBeShipped')}}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- </div> -->
    <CustomToaster
      :dataValue="toasterData"
      v-if="isToasterData"
    />
    <div
      class="bottomToUp"
      v-if="isOfferListPopup"
    ></div>
    <div
      class="bottomToUp_content offer-points"
      :class="{'activeBottomtoUp' : isOfferListPopup}"
      v-if="isOfferListPopup"
    >
      <div class="price-details">
        <h2>Offer Points</h2>
        <div class="item-detail">
          <p><span class="material-icons">check_circle</span><span><strong>26 जुलाई</strong><span> तक वेरिफ़िएड शॉप्स से कोई भी शॉपिंग करे</span></span></p>
          <p><span class="material-icons">check_circle</span><strong>₹500</strong> खरीद पूरी पर <strong>₹50</strong> कैशबैक</p>
          <p><span class="material-icons">check_circle</span><strong>₹1000</strong> खरीद पूरी पर <strong>₹250</strong> कैशबैक</p>
          <p><span class="material-icons">check_circle</span><strong>₹2000</strong> खरीद पूरी पर <strong>₹500</strong> कैशबैक</p>
        </div>
      </div>
      <span
        class="closePopUp"
        @click="isOfferListPopup =!isOfferListPopup"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="23"
          viewBox="0 0 23 23"
        >
          <path
            fill="#CDCDCD"
            fill-rule="nonzero"
            d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
            opacity=".675"
          />
        </svg>
      </span>
    </div>
    <div
      class="ftr-btn-blk"
      v-if="!$route.path.includes('/product-deal')"
    >
      <div class="button-block">
        <span
          class="button"
          @click="addToBag(sellerDetails.sellerItemRelationshipId)"
        >Buy Now</span>
      </div>
    </div>
  </div>
</template>
<script>
import constant from "@/utils/constant";
import ApiCaller from "@/utils/apicaller";
import types from "../../../store/types";
import StarRating from "vue-star-rating";
import CallIcon from "@/components/Icons/CallIcon";
import TruckIcon from "@/components/Icons/TruckIcon";
import TriangleIcon from "@/components/Icons/TriangleIcon";
import CustomToaster from "../../Common/CustomToaster";
export default {
  components: {
    StarRating,
    CallIcon,
    TruckIcon,
    TriangleIcon,
    CustomToaster,
  },
  data() {
    return {
      default_limit: 2,
      limit_by: 2,
      childCategories: [],
      openSellerList: false,
      toasterData: {},
      isToasterData: false,
      isOfferListPopup: false,
      leftTriangleValue: "16",
    };
  },
  props: {
    addToCartValue: Boolean,
    sellerDetails: Object,
    colorValue: String,
    sizeValue: String,
  },
  methods: {
    callShop(event, phoneNumber) {
      event.stopPropagation();
      try {
        JSBridgePlugin.genericIntentLaunch(`tel:+91${phoneNumber}`);
      } catch {
        console.log("error");
      }
    },
    getLocation() {
      this.$emit("getUserLocation");
    },
    viewShop(sellID) {
      // this.$store.commit("saveSubCategories", {
      //   subCategoriesDto: [],
      //   subCatId: 0
      // });
      this.$store.commit("saveCategories", {
        categories: [],
        catId: 0,
        catIndex: 0,
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      // mOST POPULAR
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      // this.$store.commit("saveMerchandiseData", {
      //   merchandiseProdList: [],
      //   merchandisePageIndex: 0
      // });
      // this.$store.commit("saveRetailShopData", {
      //   retailShopList: [],
      //   retailShopPageIndex: 0
      // });

      // this.$store.commit(types.NEW_COLLECTION, []);
      // this.$store.commit(types.MAIN_SLIDER, []);
      // this.$store.commit(types.MALL_LATEST_PRODUCT, []);
      // this.$store.commit(types.MALL_TOP_SELLING, []);
      if (sellID != this.$route.query.shopid) {
        if (this.$route.query.source === "ADS_SERVER") {
          if (this.$route.query.campaignUnitIdentifier) {
            this.$router.push(
              "/daily-needs?shopid=" +
                sellID +
                "&typeOfSource=" +
                this.$route.query.source +
                "&campaignIdentifier=" +
                this.$route.query.campaignIdentifier +
                "&campaignUnitIdentifier=" +
                this.$route.query.campaignUnitIdentifier
            );
          } else {
            this.$router.push(
              "/daily-needs?shopid=" +
                sellID +
                "&typeOfSource=" +
                this.$route.query.source +
                "&campaignIdentifier=" +
                this.$route.query.campaignIdentifier
            );
          }
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      } else {
        if (this.$route.query.source === "ADS_SERVER") {
          if (this.$route.query.campaignUnitIdentifier) {
            this.$router.push(
              "/daily-needs?shopid=" +
                sellID +
                "&typeOfSource=" +
                this.$route.query.source +
                "&campaignIdentifier=" +
                this.$route.query.campaignIdentifier +
                "&campaignUnitIdentifier=" +
                this.$route.query.campaignUnitIdentifier
            );
          } else {
            this.$router.push(
              "/daily-needs?shopid=" +
                sellID +
                "&typeOfSource=" +
                this.$route.query.source +
                "&campaignIdentifier=" +
                this.$route.query.campaignIdentifier
            );
          }
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      }
    },
    openShopOnMap(lat, long) {
      // window.location.href =  `http://www.google.com/maps/place/${lat},${long}/@${lat},${long},17z`

      try {
        JSBridgePlugin.genericIntentLaunch(
          `http://www.google.com/maps/place/${lat},${long}/@${lat},${long},17z`
        );
      } catch (err) {
        console.log(err);
      }
    },
    goToHome(sellId) {
      this.$router.push({
        path: "/?shopid=" + sellId,
      });
    },
    // addToBag(sellId){
    //   this.$emit("addToBagFunc", sellId);
    // },
    addToBag(sellId) {
      if (
        this.sellerDetails.selectableAttributes.COLOR &&
        this.sellerDetails.selectableAttributes.COLOR.length > 1
      ) {
        if (this.colorValue == null) {
          console.log(this.colorValue);
          this.toasterData = {
            msg: this.$t("pleaseSelectColor"),
            color: "#e51c24",
            iconName: "error",
          };
          this.isToasterData = true;
          return;
        }
      }
      if (
        this.sellerDetails.selectableAttributes.SIZE &&
        this.sellerDetails.selectableAttributes.SIZE.length > 1
      ) {
        if (this.sizeValue == null) {
          console.log(this.sizevalue);
          this.toasterData = {
            msg: this.$t("pleaseSelectSize"),
            color: "#e51c24",
            iconName: "error",
          };
          this.isToasterData = true;
          return;
        }
      }
      if (
        this.sellerDetails.sellerItems &&
        this.sellerDetails.sellerItems.length > 1
      ) {
        this.openSellerList = !this.openSellerList;
      } else {
        this.buyNowFunc(sellId);
      }
    },
    funcAddToBag(sellId) {
      if (this.$cookie.get("JWT-TOKEN")) {
        if (
          this.sellerDetails.selectableAttributes.COLOR &&
          this.sellerDetails.selectableAttributes.COLOR.length > 1
        ) {
          if (this.colorValue == null) {
            console.log(this.colorValue);
            this.toasterData = {
              msg: this.$t("pleaseSelectColor"),
              color: "#e51c24",
              iconName: "error",
            };
            this.isToasterData = true;
            return;
          }
        }
        if (
          this.sellerDetails.selectableAttributes.SIZE &&
          this.sellerDetails.selectableAttributes.SIZE.length > 1
        ) {
          if (this.sizeValue == null) {
            console.log(this.sizeValue);
            this.toasterData = {
              msg: this.$t("pleaseSelectSize"),
              color: "#e51c24",
              iconName: "error",
            };
            this.isToasterData = true;
            return;
          }
        }
        this.$emit("addToBagFunc", sellId);
      } else {
        this.$emit("notLoggedInUser");
      }
    },
    buyNowFunc(sellId) {
      if (this.$cookie.get("JWT-TOKEN")) {
        this.$emit("buyNowFunc", sellId);
      } else {
        this.$emit("notLoggedInUser");
      }
    },
    simple_toggle(default_limit, filters_length) {
      this.limit_by =
        this.limit_by === default_limit ? filters_length : default_limit;
    },
  },
};
</script>
<style lang="scss" scoped>
.free-delivery-tag {
  background: #b6d6f9;
  margin: 0px 15px 8px;
  padding: 8px 8px 8px 30px;
  position: relative;
  font-size: 0.85em;
  width: max-content;
  max-width: calc(100% - 63px);
  font-weight: 500;
  .truck-badge {
    padding-right: 8px;
    position: absolute;
    left: 8px;
  }
  .triangle-badge {
    // content: "";
    position: absolute;
    right: -28px;
    width: 30px;
    height: 100%;
    top: 0;
    svg,
    img {
      max-width: 100%;
      height: 100%;
      position: absolute;
      // right: -12px;
    }
  }
}
.seller-panel .seller-list .seller-dtlblk.free-delivery-tag1 {
  background: rgb(241, 241, 241);
  margin: 0px 15px 4px;
  padding: 4px 8px;
  width: calc(100% - 30px);
  border-radius: 5px;
  position: relative;
  // &::after{
  //   content: "";
  //   position: absolute;
  //   right: 0px;
  //   width: 0;
  //   height: 100%;
  //   border-top: 10px solid transparent;
  //   border-bottom: 10px solid transparent;
  //   border-right: 10px solid #fff;
  //   top: 0;
  // }
}
.new_buy_button {
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
  max-width: 767px;
  margin-right: auto;
  margin-left: auto;
  div {
    // display: flex;
    // align-items: center;
  }
  span {
    strike {
      font-size: 0.75em;
      // padding-left: 8px;
      // font-size: 1.5em;
      color: #727272;
    }
    &.price {
      // color: red;
      font-weight: 500;
      margin: 0 12px;
      margin-left: 0;
      display: inline-flex;
      font-size: 1.15em;
    }
    &.ruppee-sign {
      font-weight: normal;
      font-size: 1em;
      padding-right: 2px;
    }
  }
}
.deal-item-added {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.order_button .large_group_btn {
  padding: 18px 15px;
}
.order_button .large_group_btn.group {
  background: red !important;
  padding: 7px 15px;
  font-size: 1.2em;
  font-weight: 600;
  margin: 8px 0 8px 20px;
  border-radius: 5px;
  width: 85%;
}
.order_button .large_group_btn span {
  font-size: inherit;
  text-transform: uppercase;
}
.new-add-to-bag {
  background: rgb(255, 255, 255);
  color: rgb(0, 143, 0);
  border: 1px solid rgb(0, 143, 0);
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 0.938em;
  font-weight: 600;
}
.all-seller-list {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: #fff;
}
.seller-panel .seller-list .addtoBuyNow-col {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  z-index: 9;
  font-size: 1em;
  text-align: center;
  white-space: nowrap;
  background: #008f00;
  color: #fff;
  padding: 8px 12px;
  text-transform: uppercase;
}
.seller-panel .seller-list .shop-action-blk .view-shop {
  // width:100%;
}
.seller-shop-name {
  font-weight: 600;
  padding-bottom: 8px;
  font-size: 0.875em;
  display: block;
  text-transform: capitalize;
  display: flex;
  // justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 80%;
  .is-verified {
    width: 65px;
    display: block;
    margin-left: 4px;
    position: absolute;
    right: 0;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.star-rating {
  padding-left: 16px;
  padding-top: 4px;
  // margin-bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  span {
    color: #0091ff;
    font-size: 0.75em;
    padding-left: 8px;
    // padding-top: 4px;
    font-weight: 600;
  }
}
.call-icon {
  width: 28px;
  height: 28px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0063d3;
  border-radius: 50%;

  svg {
    width: 12px;
    height: 12px;
    path {
      fill: #0063d3;
      stroke: #0063d3;
    }
  }
}
</style>
